import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { LazyLoadEvent, SelectItem, Table } from 'primeng';
import { ImportDataType } from '../../interfaces/data-import/import-data-type';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IPageResult } from '../../interfaces/page-result';
import { IPreferredSupplier } from '../../interfaces/preferred-supplier';
import { IPreferredSupplierFilter } from '../../interfaces/preferred-supplier-filter';
import { MapService } from '../../services';
import { PreferredSupplierService } from '../../services';
import { PreferredSupplierChangeStatus } from '../../services';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

declare var pca: any;

@Component({
  selector: 'preferred-supplier',
  templateUrl: './preferred-supplier.component.html',
  styleUrls: ['./preferred-supplier.component.css'],
})
export class PreferredSupplierComponent implements OnInit {
  public page: IPageResult<IPreferredSupplier> = {
    items: [],
    total: 0,
  };

  public selectedItem;

  public filter: Subject<IPreferredSupplierFilter>;
  public filterVal: IPreferredSupplierFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public preferredSupplier: IPreferredSupplier;
  public newPotentialPreferredSupplier: boolean = false;
  public filterString: string;
  public control: any;
  public newPreferredSupplierForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public addressLine1: UntypedFormControl;
  public addressLine2: UntypedFormControl;
  public addressLine3: UntypedFormControl;
  public town: UntypedFormControl;
  public postcode: UntypedFormControl;
  public emailAddress: UntypedFormControl;

  constructor(
    private preferredSupplierService: PreferredSupplierService,
    private preferredSupplierChangeStatus: PreferredSupplierChangeStatus,
    private mapService: MapService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initDefaultFilter();

    this.preferredSupplier = {
      id: 0,
      name: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      town: '',
      postcode: '',
      emailAddress: '',
      quality: '',
      status: '',
    };

    this.filter = new Subject<IPreferredSupplierFilter>();

    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filter.next(this.filterVal);

    this.mapService.GetPCAKey().then((result) => {
      if (!result) return;

      setTimeout(() => {
        var fields = [
          {
            element: 'name',
            field: 'Company',
            mode: pca.fieldMode.POPULATE | pca.fieldMode.SEARCH,
          },
          {
            element: 'addressLine1',
            field: 'Line1',
            mode: pca.fieldMode.POPULATE | pca.fieldMode.SEARCH,
          },
          { element: 'addressLine2', field: 'Line2', mode: pca.fieldMode.POPULATE },
          { element: 'town', field: 'City', mode: pca.fieldMode.POPULATE },
          {
            element: 'postcode',
            field: 'PostalCode',
            mode: pca.fieldMode.POPULATE | pca.fieldMode.SEARCH,
          },
        ];

        var options = {
          key: result.key,
        };
        var control = new pca.Address(fields, options);
        control.load();

        control.listen('populate', (address, variations) => {
          this.newPreferredSupplierForm.patchValue({
            id: 0,
            name: $('#name').val(),
            addressLine1: $('#addressLine1').val(),
            addressLine2: $('#addressLine2').val(),
            addressLine3: $('#addressLine3').val(),
            town: $('#town').val(),
            postcode: $('#postcode').val(),
          });
        });
      }, 0);
    });

    const regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

    this.name = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
    );
    this.addressLine1 = new UntypedFormControl('', Validators.maxLength(35));
    this.addressLine2 = new UntypedFormControl('', Validators.maxLength(35));
    this.addressLine3 = new UntypedFormControl('', Validators.maxLength(35));
    this.town = new UntypedFormControl('', Validators.maxLength(35));
    this.postcode = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(8)]),
    );
    this.emailAddress = new UntypedFormControl(
      '',
      Validators.compose([
        Validators.required,
        Validators.maxLength(254),
        Validators.pattern(regexp),
      ]),
    );

    this.newPreferredSupplierForm = new UntypedFormGroup({
      id: new UntypedFormControl(0),
      name: this.name,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      addressLine3: this.addressLine3,
      town: this.town,
      postcode: this.postcode,
      emailAddress: this.emailAddress,
    });
  }

  load(filter: IPreferredSupplierFilter) {
    this.preferredSupplierService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
      console.log(this.page.items);
    });
  }

  showDialogToAdd() {
    this.newPotentialPreferredSupplier = true;
    this.preferredSupplier = {
      id: 0,
      name: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      town: '',
      postcode: '',
      emailAddress: '',
      quality: '',
      status: '',
    };
    this.resetFormValues(this.preferredSupplier);
    this.displayDialog = true;
  }

  save(formValues) {
    this.preferredSupplier.id = formValues.id;
    this.preferredSupplier.name = formValues.name.trim();
    this.preferredSupplier.addressLine1 = formValues.addressLine1;
    this.preferredSupplier.addressLine2 = formValues.addressLine2;
    this.preferredSupplier.addressLine3 = formValues.addressLine3;
    this.preferredSupplier.town = formValues.town;
    this.preferredSupplier.postcode = formValues.postcode;
    this.preferredSupplier.emailAddress = formValues.emailAddress;

    if (this.preferredSupplier.name !== '') {
      this.preferredSupplierService
        .create(this.preferredSupplier)
        .then((res) => this.load(this.filterVal));
    }
    this.displayDialog = false;
  }

  showDialogToEdit(prefSupplier) {
    console.log(prefSupplier);
    if (prefSupplier) {
      this.newPotentialPreferredSupplier = true;
      this.resetFormValues(prefSupplier);
      this.displayDialog = true;
    }
  }

  close() {
    this.displayDialog = false;
  }

  resetFormValues(formValues) {
    this.newPreferredSupplierForm.setValue({
      id: formValues.id,
      name: formValues.name,
      addressLine1: formValues.addressLine1,
      addressLine2: formValues.addressLine2,
      addressLine3: formValues.addressLine3,
      town: formValues.town,
      postcode: formValues.postcode,
      emailAddress: formValues.emailAddress,
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    //var eventString = JSON.stringify(event);
    //if (eventString === this.filterString) return;
    //this.filter.next(flatten(event));

    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  changeStatus(id: number) {
    this.preferredSupplierChangeStatus.get(id).then((result) => {
      if (result.status !== undefined) {
        this.page.items.forEach((item) => {
          if (item.id === result.id && item.status !== 'invited') {
            item.status = result.status;
          }
        });
      }
    });
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'Name', // ASC
      sortOrder: 1,
      filters: {
        name: {},
        quality: {},
        status: {},
      },
    };
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    console.log(this.filterVal);
    this.filter.next(this.filterVal);
  }

  goToImportData() {
    this.router.navigate(['app/dataimport/' + ImportDataType.Suppliers]);
  }
}
